export default "__VITE_ASSET__DzWtnVoj__"